import { z } from "zod";

// remove when backend is fully updated to use strings for laneType
export const laneTypeMap: Record<
  (typeof allowedLaneTypes)[0 | 1 | 2 | 3 | 4 | 5 | 6 | 7],
  number
> = {
  Regular: 0,
  Split: 1,
  Merged: 2,
  InboundTrap: 3,
  LinehaulTrap: 4,
  OutboundTrap: 5,
  Unassigned: 6,
  Osad: 7,
} as const;

export const isTrapType = (laneType: LaneType) =>
  [
    laneTypeMap.OutboundTrap,
    laneTypeMap.LinehaulTrap,
    laneTypeMap.InboundTrap,
  ].includes(laneType);

// this will be the preferred approach going forward, as the backend will be returning strings for laneType
export const allowedLaneTypes = [
  "Regular",
  "Split",
  "Merged",
  "InboundTrap",
  "LinehaulTrap",
  "OutboundTrap",
  "Unassigned",
  "Osad",
] as const;

export type LaneType = (typeof laneTypeMap)[keyof typeof laneTypeMap];

export const laneTypeSchema = z.nativeEnum(laneTypeMap);
